import { StockMarketConstants as ConstantsType } from "@nsdefs";

export const StockMarketConstants: ConstantsType = {
  msPerStockUpdate: 6e3,
  msPerStockUpdateMin: 4e3,
  TicksPerCycle: 75,
  WseAccountCost: 200e6,
  TixApiCost: 5e9,
  MarketData4SCost: 1e9,
  MarketDataTixApi4SCost: 25e9,
  StockMarketCommission: 100e3,
};
